import { HTTP } from "@/api";

export default {
  getCompanies({ commit }) {
    commit("isLoading", {
      key: "company",
      status: true
    });
    return HTTP.get("/company")
      .then(res => {
        if (res.data && res.data.success) commit("companies", res.data.result);
      })
      .finally(() =>
        commit("isLoading", {
          key: "company",
          status: false
        })
      );
  }
};
